<div (click)="openModal()" class="mutual-funds-widget" [class.mutual-funds-widget--small]="size === 'small'"
    [class.mutual-funds-widget--medium]="size !== 'small'">

    <!-- Header -->
    <div class="mutual-funds-widget__header">
        <div class="mutual-funds-widget__header-content">
            <div class="mutual-funds-widget__title">{{ title }}</div>
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" class="mutual-funds-widget__icon-container"
                    cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                    <div class="mutual-funds-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <!-- Stock Name -->
    <div class="mutual-funds-widget__stock-name">{{ stockName }}</div>

    <!-- Chart Content -->
    <div class="mutual-funds-widget__content">
        <div class="mutual-funds-widget__chart-area">
            <!-- Chart Container -->
            <div class="mutual-funds-widget__chart-container" [style.height.px]="chartContainerHeight">
                <canvas #fundCanvas (mousemove)="onCanvasHover($event)" (mouseleave)="hideTooltip()"></canvas>

                <!-- Current Value Badge - positioned on dashed line for sizes > small -->
                <div class="mutual-funds-widget__value-badge"
                    [style.top.px]="size !== 'small' ? badgeTopPosition : null"
                    [class.mutual-funds-widget__value-badge--dynamic]="size !== 'small'">
                    <span class="mutual-funds-widget__value-text">{{ currentValue }}</span>
                </div>

                <!-- Tooltip -->
                <div class="mutual-funds-widget__tooltip" *ngIf="hoveredData && tooltipVisible"
                    [style.top.px]="tooltipPosition.y" [style.left.px]="tooltipPosition.x">
                    <div class="mutual-funds-widget__tooltip-amount">{{ formatValue(hoveredData.value) }}</div>
                    <div class="mutual-funds-widget__tooltip-date">{{ hoveredData.date }}</div>
                </div>
            </div>

            <!-- X-Axis Labels -->
            <div class="mutual-funds-widget__x-axis">
                <div class="mutual-funds-widget__x-label" *ngFor="let label of displayXAxisLabels">{{ label }}</div>
            </div>
        </div>

        <!-- Y-Axis Labels -->
        <div class="mutual-funds-widget__y-axis" [style.height.px]="chartContainerHeight">
            <div class="mutual-funds-widget__y-label" *ngFor="let item of yAxisLabelsWithPosition"
                [style.top.%]="item.topPercent">{{ item.label }}</div>
        </div>
    </div>
</div>